module.exports = __webpack_public_path__ + "media/components/img/logo-mark-purple-dd4c6df1abf83eadbe8abd5fbd6e6449.svg";